import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { Add, FilterAlt } from "@mui/icons-material"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import { useEffect, useState } from "react"
import Table from "../../../components/Table/index.js"
import FieldMappingFilterDialog from './components/FieldMappingFilterDialog.js';

const FieldMappingList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.apiFieldMappingStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.apiFieldMappingStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.apiFieldMappingStore?.totalPages);

    const [fieldMappingData, setFieldMappingData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        fieldId: "",
        iRegistryId: "",
        apiCategoryId: "",
        transformFnId: "",
        dataDirectionId: ""
    });

    useEffect(() => {
        fetchFieldMappingList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchFieldMappingList = async () => {
        setCircleLoading(true);
        try {   
        let url = `/api-engine/field-mapping?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.fieldId !== "" && filterData.fieldId !== null && filterData.fieldId !== undefined) {
            url += `&fieldId=${filterData.fieldId}`;
        }
        if(filterData.iRegistryId !== "" && filterData.iRegistryId !== null && filterData.iRegistryId !== undefined) {
            url += `&iRegistryId=${filterData.iRegistryId}`;
        }
        if(filterData.apiCategoryId !== "" && filterData.apiCategoryId !== null && filterData.apiCategoryId !== undefined) {
            url += `&apiCategoryId=${filterData.apiCategoryId}`;
        }
        if(filterData.transformFnId !== "" && filterData.transformFnId !== null && filterData.transformFnId !== undefined) {
            url += `&transformFnId=${filterData.transformFnId}`;
        }
        if(filterData.dataDirectionId !== "" && filterData.dataDirectionId !== null && filterData.dataDirectionId !== undefined) {
            url += `&dataDirectionId=${filterData.dataDirectionId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setFieldMappingData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching List", "error")
        }
        } catch (error) {
            console.error('Error Fetching List:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/api-engine/field-mapping-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Error deleting data", "error");
        }
    };

    //table mapping
    const fieldMappingTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },            
            {
            key: "apiCategory",
            label: "API Category",
            renderCell: (row) => row.apiCategory,
            },
            {
            key: "fieldDictionary",
            label: "Field Dictionary",
            renderCell: (row) => row.fieldDictionary,
            },
            {
            key: "dataDirection",
            label: "Data Direction",
            renderCell: (row) => row.dataDirection,
            },
            {
            key: "mappingConfig",
            label: "Mapping Config",
            renderCell: (row) => row.mappingConfig,
            isObject: true,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row.createdAt,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            }
        ],
        rows: fieldMappingData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            fieldDictionary: item?.fieldDictionary?.name || "",
            apiCategory: item?.apiCategory?.keyName || "",
            dataDirection: item?.dataDirection?.keyName || "",
            mappingConfig: item?.mappingConfig || "-",
            createdAt: new Date(item?.createdAt).toLocaleDateString("en-IN"),
            isActive: item?.isActive
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/api-integration-engine/field-mapping/field-mapping-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/api-integration-engine/field-mapping/field-mapping-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };
    

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Field Mapping List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Field Mappings.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}

                    >
                        Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/api-integration-engine/field-mapping/field-mapping-details')}
                    >
                        Field Mapping
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
            <Table
            columns={fieldMappingTable?.columns}
            data={fieldMappingTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Field Mapping Data found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <FieldMappingFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);
            fetchFieldMappingList();
        }}
        />
    </DashboardLayout>
  )
}

export default FieldMappingList